module.exports = __webpack_public_path__ + "ea6051ba89cfc1afad86c0f230335ade.svg";